export const absenceDurationFormat = (hours, minutes) => {
    return hours + ':' + minutes;
};
